document.querySelectorAll('.js-print').forEach(($target) => {
  $target.addEventListener('click', (event) => {
    // Prevent default event
    event.preventDefault();

    // Print site
    window.print();
  });
});
